import { 
  doc, 
  getDoc, 
  setDoc, 
  updateDoc 
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION_NAME = 'settings';
const SETTINGS_DOC_ID = 'billing'; // Single document for billing settings

// Get billing settings
export const getBillingSettings = async () => {
  try {
    const settingsDoc = await getDoc(doc(db, COLLECTION_NAME, SETTINGS_DOC_ID));
    if (settingsDoc.exists()) {
      return { success: true, data: settingsDoc.data() };
    }
    // Return default settings if not found
    return { 
      success: true, 
      data: {
        companyName: 'Roshan Gram Store',
        companyAddress: '123 Business Street, City, State 12345',
        companyPhone: '+1 (234) 567-8900',
        companyEmail: 'info@roshangramstore.com',
        taxRate: '10',
        currency: 'LKR',
        invoicePrefix: 'INV',
        includeCompanyLogo: true,
        includeTermsAndConditions: true,
        includePaymentInstructions: true,
        includeTaxBreakdown: true,
        includeDiscountField: true,
        includeNotes: true,
        termsText: 'Payment is due within 30 days. Late payments may incur additional charges.',
        paymentInstructions: 'Please make payment via bank transfer or credit card.',
        globalDiscount: {
          enabled: false,
          type: 'percentage',
          value: 0,
          reason: '',
        },
      }
    };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Save billing settings — uses merge so existing fields not in the form are preserved
export const saveBillingSettings = async (settings) => {
  try {
    await setDoc(doc(db, COLLECTION_NAME, SETTINGS_DOC_ID), {
      ...settings,
      updatedAt: new Date().toISOString()
    }, { merge: true });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Update billing settings
export const updateBillingSettings = async (settings) => {
  try {
    const settingsRef = doc(db, COLLECTION_NAME, SETTINGS_DOC_ID);
    await updateDoc(settingsRef, {
      ...settings,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
